import { RenderWalletState } from "@sundaeswap/wallet-lite";
import { FC, lazy } from "react";

import { ConnectWalletButton } from "./ConnectWalletButton";

const LazyWalletDetailsPopover = lazy(() => import("./WalletDetailsPopover"));

interface WalletConnectProps {
  className?: string;
  compact?: boolean;
}

export const WalletConnect: FC<WalletConnectProps> = ({ className, compact = false }) => {
  return (
    <RenderWalletState
      loader={
        <div className="w-5 h-5 rounded-full border-2 border-sr-lemon-muted border-t-transparent animate-spin" />
      }
      fallback={
        <button
          className={`sr-focus-ring sr-surface-pill w-auto flex items-center gap-1.5 rounded-full px-4 py-2 text-sm font-medium text-sr-oat-milk transition-colors hover:bg-sr-surface-raised ${className ?? ""}`}
          onClick={() => window.location.reload()}
        >
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M7 1.5V3.5M7 10.5V12.5M1.5 7H3.5M10.5 7H12.5" stroke="var(--color-sr-tangerine)" strokeWidth="1.5" strokeLinecap="round" />
          </svg>
          Reload
        </button>
      }
      render={({ willAutoConnect, ready }) => {
        if (willAutoConnect || ready) {
          return <LazyWalletDetailsPopover className={className} compact={compact} />;
        }

        return <ConnectWalletButton className={className} compact={compact} />;
      }}
    />
  );
};
